class NscSubscriptionSchedule extends HTMLElement {
  connectedCallback() {
    this.renderSchedule();
  }

  renderSchedule() {
    const body = this.querySelector('[data-schedule-body]');
    const today = this.parseDate(this.dataset.today);
    const months = Number.parseInt(this.dataset.months, 10);

    if (!body || !today || !Number.isInteger(months) || months < 1) return;

    const formatter = new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC',
      weekday: 'short',
    });
    const overrides = this.getOverrides();
    const firstScheduleMonth = this.getNextScheduleMonth(today);
    const rows = document.createDocumentFragment();

    for (let index = 0; index < months; index += 1) {
      const scheduleMonth = new Date(
        Date.UTC(firstScheduleMonth.getUTCFullYear(), firstScheduleMonth.getUTCMonth() + index, 1),
      );
      const roasted = this.getCalendarWeekMonday(scheduleMonth.getUTCFullYear(), scheduleMonth.getUTCMonth());
      const dispatched = this.addDays(roasted, 1);
      const arrivesBy = this.addDays(roasted, 4);
      const override = overrides.get(this.toIsoDate(roasted));
      const row = document.createElement('tr');

      row.append(
        this.createDateCell(roasted, override?.roasted, formatter),
        this.createDateCell(dispatched, override?.dispatched, formatter),
        this.createDateCell(arrivesBy, override?.arrivesBy, formatter),
      );
      rows.append(row);
    }

    body.replaceChildren(rows);
  }

  getOverrides() {
    const overrides = new Map();

    this.querySelectorAll('[data-schedule-override]').forEach((element) => {
      if (!this.parseDate(element.dataset.roastDate)) return;

      overrides.set(element.dataset.roastDate, {
        arrivesBy: element.dataset.arrivesBy?.trim(),
        dispatched: element.dataset.dispatched?.trim(),
        roasted: element.dataset.roasted?.trim(),
      });
    });

    return overrides;
  }

  createDateCell(date, override, formatter) {
    const cell = document.createElement('td');

    if (override) {
      cell.textContent = override;
      return cell;
    }

    const time = document.createElement('time');
    time.dateTime = this.toIsoDate(date);
    time.textContent = formatter.format(date);
    cell.append(time);
    return cell;
  }

  parseDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const date = new Date(Date.UTC(year, month, day));

    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month || date.getUTCDate() !== day) return null;
    return date;
  }

  getNextScheduleMonth(today) {
    let scheduleMonth = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1));
    let roastDate = this.getCalendarWeekMonday(scheduleMonth.getUTCFullYear(), scheduleMonth.getUTCMonth());

    while (roastDate < today) {
      scheduleMonth = new Date(Date.UTC(scheduleMonth.getUTCFullYear(), scheduleMonth.getUTCMonth() + 1, 1));
      roastDate = this.getCalendarWeekMonday(scheduleMonth.getUTCFullYear(), scheduleMonth.getUTCMonth());
    }

    return scheduleMonth;
  }

  getCalendarWeekMonday(year, month) {
    const firstOfMonth = new Date(Date.UTC(year, month, 1));
    const daysSinceMonday = (firstOfMonth.getUTCDay() + 6) % 7;
    return this.addDays(firstOfMonth, -daysSinceMonday);
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  toIsoDate(date) {
    return date.toISOString().slice(0, 10);
  }
}

if (!customElements.get('nsc-subscription-schedule')) {
  customElements.define('nsc-subscription-schedule', NscSubscriptionSchedule);
}
